import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./../assets/css/topbar.css";
import "./../assets/sass/_topbar.scss";
import { TfiMenuAlt } from "react-icons/tfi";
import InputComponent from "./InputComponent";
import { MdKeyboardArrowDown } from "react-icons/md";

import { API_SRC, validateHeader, API_Link } from "../commons/Constants";
import axios from "axios";
import { useSelector, useDispatch } from 'react-redux';
import TopbarChildComponent from "./childComponents/TopbarChildComponent";
import { getPermission } from "../features/setting/permissionSlice";

function TopBar() {
  const [studyId, setStudyId] = useState(localStorage.getItem("studyId"));
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [reviewList, setFilteredReview] = useState([]);
  const [isTeamlead, setIsTeamlead] = useState(false);
  const [currentPage, setCurrentPage] = useState(localStorage.getItem("pageId") || "");
  const dispatch = useDispatch();
  const MD5hash = validateHeader();
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token;

  const permission1 = useSelector((state) => state?.getPermission?.data);

  const getReviewsList = () => {
    var config = {
      method: "get",
      url: `${API_Link}getReviewsList`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
    };
    axios(config)
      .then(function (response) {
        const valuesArray = response.data.reviews;
        if (localStorage.getItem("studyId") == null && valuesArray.length > 0) {
          localStorage.setItem("studyId", valuesArray[0].id);
          setStudyId(valuesArray[0].id); // Set the default studyId to the first review
        }
        setFilteredReview(valuesArray);
        setLoading(false); // Set loading to false after fetching data
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false); // Ensure loading is set to false even on error
      });
  };
  useEffect(() => {
    const storedStudyId = localStorage.getItem("studyId");
    if (storedStudyId) {
      setStudyId(storedStudyId);
    }

    dispatch(getPermission());
    getReviewsList();
    setLoading(false);

    if (user.role.role === 'teamlead') {
      setIsTeamlead(true);
    }
    const storedPageId = localStorage.getItem("pageId");
    if (storedPageId) {
      setCurrentPage(storedPageId);
    }
  }, [dispatch, user?.role?.role, location?.pathname]);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);
  const storedStudyId = localStorage.getItem("studyId");

  const studyCheck = (selectedId) => {
    setStudyId(selectedId);
    localStorage.setItem("studyId", selectedId);
    const selectedPageId = reviewList.find(review => review.id === selectedId)?.link;
    if (selectedPageId) {
      localStorage.setItem("pageId", selectedPageId);
      setCurrentPage(selectedPageId);
    }

    // Reload the page
    window.location.reload();
  };
  const handleClick = (event) => {
    const pageId = event.currentTarget.id;
    localStorage.setItem("pageId", pageId);
    setCurrentPage(pageId);
  };
  const sidebars = JSON.parse(localStorage.getItem("user"));
  const menus = sidebars.menu;
  const topBarMenu = menus.filter((menu) => menu.module === "topBar");
  const selectedTitle = loading
    ? "Loading..."
    :
    studyId && reviewList.length > 0
      ? reviewList.find(item => item.id == studyId)?.title || "Select an option"
      : "Select an option";

  if (loading) return null;

  return (
    <>
      {user.role.role === 'admin' ? <TopbarChildComponent /> : (
        <div className='row top_bar_first'>
          <h2 className='col-11'>
            {window.location.pathname === "/dashboard" ? (
              <InputComponent for={"top_bar"} type={"text"} placeholder={"MaHTAS Intelligent Systematic Review System"} disabled />
            ) : (
              <div ref={dropdownRef} style={{ position: "relative", width: "100%" }} className="main-select-dropDown">
                <div
                  style={{
                    padding: "10px",
                    border: "1px solid #ccc",
                    cursor: "pointer",
                    fontSize: "16px",
                    display: "flex",
                    borderRadius: "8px",
                    backgroundColor: "#f2f2f2",
                    justifyContent: "space-between"
                  }}
                  onClick={toggleDropdown}
                >
                  {selectedTitle}
                  <span>
                    <MdKeyboardArrowDown size={25} />
                  </span>

                </div>

                {dropdownOpen && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "0",
                      width: "100%",
                      maxHeight: "60vh",
                      border: "1px solid #ccc",
                      borderTop: "none",
                      overflowY: "auto",
                      backgroundColor: "#f3f3f3",
                      zIndex: "1"
                    }}
                  >
                    {reviewList
                      .sort((a, b) => (a.id < b.id ? 1 : -1))
                      .map(({ title, id }, index) => (
                        <div
                          className="top-select-hover"
                          key={index}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            fontSize: "16px"
                          }}
                          onClick={() => {
                            studyCheck(id);
                            localStorage.setItem("title", title)
                          }}
                        >
                          {title.length > 100 ? `${title.slice(0, 100)}...` : title}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            )}
          </h2>
          {isTeamlead && (
            <div className='col-1 icon'>
              <Link to='/review' style={{ color: "black" }}>
                <TfiMenuAlt className='iconfirst' />
              </Link>
            </div>
          )}
        </div>
      )}

      <div className="top-bar">
        <div className="topbar-link">
          {topBarMenu.map((topLink, index) => (
            <Link
              onClick={handleClick}
              key={index}
              id={topLink.id}
              to={"/" + (topLink.link==="admin/actions"?"admin/users":topLink.link)}
              className={`li ${topLink.id == localStorage.getItem("pageId") ? "active" : ""}`}
            >
              <img src={API_SRC + topLink.icon} alt="" /> {topLink.title}
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}

export default TopBar;
